'use client';

import { TbBrandHipchat } from 'react-icons/tb';

// Div "fale com a gente" que abre o ChatWidget (mesmo visual do "Falar com vendas"
// da /precos). Botão no gradiente Trakd Soft + ícone do chat (TbBrandHipchat).
// Dispara `trakd:open-chat` com um prefill opcional pro input do chat.
const STYLES = `
.chat-cta { position:relative; overflow:hidden; display:flex; align-items:center; gap:18px; padding:24px 26px; border-radius:20px; border:1px solid rgba(222,219,246,.10); background:linear-gradient(120deg, rgba(139,146,231,.10), rgba(144,97,255,.06)); flex-wrap:wrap; }
.chat-cta::before { content:""; position:absolute; right:-40px; top:-60px; width:220px; height:220px; border-radius:50%; background:#8B92E7; opacity:.10; filter:blur(60px); }
.chat-cta-ic { position:relative; z-index:1; width:48px; height:48px; border-radius:14px; background:linear-gradient(135deg,#8B92E7 0%,#DEDBF6 100%); display:grid; place-items:center; flex:none; color:#1a1430; box-shadow:0 8px 22px rgba(139,146,231,.4); }
.chat-cta-txt { position:relative; z-index:1; }
.chat-cta-tt { font-size:17px; font-weight:700; color:#fff; }
.chat-cta-ds { font-size:13.5px; color:#C0BDD5; margin-top:3px; }
.chat-cta-btn { position:relative; z-index:1; margin-left:auto; background:linear-gradient(135deg,#8B92E7 0%,#DEDBF6 100%); color:#1a1430; font-weight:700; font-size:14px; padding:12px 22px; border-radius:13px; border:none; cursor:pointer; display:inline-flex; align-items:center; gap:9px; transition:transform .2s, box-shadow .2s; box-shadow:0 8px 22px rgba(139,146,231,.35); }
.chat-cta-btn:hover { transform:translateY(-1px); box-shadow:0 12px 28px rgba(139,146,231,.5); }
@media(max-width:680px){ .chat-cta-btn { margin-left:0; width:100%; justify-content:center; } }
`;

interface Props {
  title: string;
  description: string;
  label: string;
  /** Texto inicial pré-preenchido no input do chat (opcional). */
  prefill?: string;
}

export function ChatCta({ title, description, label, prefill }: Props) {
  return (
    <div className="chat-cta">
      <style dangerouslySetInnerHTML={{ __html: STYLES }} />
      <span className="chat-cta-ic">
        <TbBrandHipchat size={24} strokeWidth={1.8} />
      </span>
      <div className="chat-cta-txt">
        <div className="chat-cta-tt">{title}</div>
        <div className="chat-cta-ds">{description}</div>
      </div>
      <button
        type="button"
        className="chat-cta-btn"
        onClick={() => {
          window.dispatchEvent(new CustomEvent('trakd:open-chat', { detail: { prefill } }));
        }}
      >
        <TbBrandHipchat size={18} strokeWidth={1.8} />
        {label}
      </button>
    </div>
  );
}
